var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.255 47.255"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.314 47.255a.999.999 0 01-.707-1.707l21.92-21.92-21.92-21.92A.999.999 0 1113.021.294L35.648 22.92a.999.999 0 010 1.414L13.021 46.962a.999.999 0 01-.707.293z"
  })));
}
export default SvgIconRightArrow;